<template>
  <!-- <div class="Dialog error" v-show="state.context && state.context.alertInfo && state.context.alertInfo.msg">  -->
  <div class="Dialog error error--style" v-show="isShown">
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld" v-if="!state.context.alertInfo.cancelBtn"></div>
      <div class="pic-cloud" v-if="!state.context.alertInfo.cancelBtn"></div>
      <div class="icon-close" @click="closeAlert" v-if="!state.context.alertInfo.disableClose"></div>

      <div class="title"><span>温馨提示</span></div>

      <div class="inner-body">
        <p class="content" v-html="state.context.alertInfo.msg"></p>
        <p class="content" v-if="state.context.alertInfo.miniMsg" style="font-weight: bold;">{{ state.context.alertInfo.miniMsg }}</p>
        <div class="btns">
          <button class="btn" @click="cancelFunc" v-if="state.context.alertInfo.cancelBtn">{{ state.context.alertInfo.cancelBtn || "取消" }}</button>
          <button :class="[ 'btn', state.context.alertInfo.cancelBtn ? 'btn--bg' : '' ]" @click="confirmFunc">{{ state.context.alertInfo.confirmBtn || "确认" }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
import * as inGameApi from "../../common/utils/inGame"

export default {
  name: "AlertDialog",
  props: ["state", "send"],
  setup(props) {
    const isShown = computed(() => {
      return [
        "participate.fight.freetask.checkSuccess.todo.alert",
        "participate.fight.freetask.checkSuccess.complete.receiveSuccess.alert",
        "participate.orderAndFight.select.alert",
        "participate.orderAndFight.select.selectfreetask.checkSuccess.complete.receiveSuccess.alert"
      ].some(props.state.matches)
    })

    const closeAlert = () => {
      props.send("CLOSE_ALERT")
    }

    const confirmFunc = () => {
      if (props.state.context.alertInfo?.confirmType == "lottery") {
        // 自动开奖
        props.send("SELECT_LOTTERY", { present_rank: 1 })
      } else if (props.state.context.alertInfo?.confirmType == "buy") {
        // let productid = props.state.context.purchaseInfo.product_id
        props.send("SELECT_ORDER")
      } else {
        // 没有对局过，游戏外拉起游戏，游戏内关闭弹窗
        if (props.state.context.alertInfo && props.state.context.alertInfo.jumpUrlOutGame) {
          // 游戏内去对战
          if (props.state.context.userAgent.msdk) {
            inGameApi.jumpGameSence(4)
          } else {
            location.href = props.state.context.alertInfo.jumpUrlOutGame
          }
        }

        // 对局过，关闭弹窗-回到活动首页，玩家手动开奖
        closeAlert()
      }
    }

    const cancelFunc = () => {
      props.send("CHECK_FIGHT")
    }

    return {
      isShown,
      closeAlert,
      confirmFunc,
      cancelFunc
    }
  }
}
</script>

<style scoped>
</style>
